<template>
  <div v-if="resourceType" style="max-width: 800px">
    <div v-if="!loading">

      <fob-entity-header
        :type="resourceSchema.label"
        :title="resourceData._stringRep"
        :createUser="resourceData._createUser"
        :createDate="resourceData._createDate"
        :updateUser="resourceData._updateUser"
        :updateDate="resourceData._updateDate"
      ></fob-entity-header>

      <!-- D E S C R I P T I O N -->
      <!-- <div class="fob-box box">
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Optio, quibusdam?
        Debitis velit cumque nam, amet libero dignissimos distinctio quod autem laboriosam alias.
      </div> -->

      <fob-entity-create-form
        @update:invalid="value => isInvalid = value"
        :showErrors="showErrors"
        :key="$route.params.id"
        :type="resourceType"
        :schema="resourceSchema"
        @input="updateData()"
        v-model="resourceData"
      ></fob-entity-create-form>

      <div style="margin-top: 40px">
        <b-field grouped>
          <p class="control">
            <button @click="requestSave" :disabled="!isDirty" class="button is-aquamarine">Speichern</button>
          </p>
          <p class="control">
            <button @click="close()" :disabled="!isDirty" class="button is-carnelian">Änderungen verwerfen</button>
          </p>
        </b-field>
      </div>
    </div>
  </div>
  <div class="section" style="max-width: 1200px" v-else>
    <div class="columns">
      <div class="column" style="max-width: 50px;">
        <b-icon icon="exclamation" type="is-aquamarine" size="is-large"></b-icon>
      </div>
      <div class="column">
        Hier können Sie eine bereits angelegte Ressource / Forschungsaktivität bearbeiten und eine
        aktualisierte Version speichern. Im Moment haben Sie noch <strong>keine</strong> Ressource
        zur Bearbeitung ausgewählt. Nutzen Sie dafür die <router-link to="auflisten">Listenansicht</router-link>
        oder den "Bearbeiten"-Button in der <router-link to="zeige">Detailansicht.</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import schema from '@/schema'
import EntityHeader from '@/components/EntityHeader'
import store from '@/store'
import ValidateAndSave from '@/components/mixins/ValidateAndSave'
import DynamicTitle from '@/components/mixins/DynamicTitle'

export default {
  name: 'fob-entity-edit',
  mixins: [ValidateAndSave, DynamicTitle],
  data () {
    return {
      resourceTypes: schema.baseTypes,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.editor'
      }
    }
  },
  methods: {
    save () {
      this.saveAndDispatch('editor/saveEntity')
    },
    close () {
      this.$store.dispatch('editor/closeEditor')
      .then((data) => {
        this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: data.type,
            resourceId: data.id
          }
        })
      })
    },
    updateData () {
      this.$store.dispatch('editor/setData', this.resourceData)
    }
  },
  computed: {
    ...mapGetters({
      isDirty: 'editor/isDirty',
      resourceSchema: 'editor/getSchema',
      resourceId: 'editor/getId',
      resourceType: 'editor/getViewEntityType',
      loading: 'editor/isLoading'
    }),
    resourceData: {
      get () {
        return this.$store.getters['editor/getData']
      },
      set (value) {
        this.$store.dispatch('editor/setData', value)
      }
    },
    selectedType: {
      get () {
        if (this.viewEntityType === null) {
          return null
        } else {
          const sel = this.resourceTypes.findIndex(x => x.schema.route === this.viewEntityType)
          if (sel === -1) {
            this.$router.replace({
              name: 'editieren'
            })
            return null
          }
          return sel
        }
      },
      set (v) {
        if (v !== null) {
          this.$router.push({
            name: 'editieren',
            params: {
              resourceType: this.resourceTypes[v].schema.route,
              resourceId: 1
            }
          })
        }
      }
    },
    id: {
      get () {
        return this.$store.getters['editor/getId']
      },
      set (value) {
        this.$router.push({
          name: 'editieren',
          params: {
            resourceType: this.resourceSchema.route,
            resourceId: value
          }
        })
      }
    }
  },
  components: {
    'fob-entity-header': EntityHeader
  },
  beforeRouteEnter (to, from, next) {
    let resourceId = store.getters['editor/getId']
    let resourceType = store.getters['editor/getViewEntityType']
    if (resourceType != null && (to.params.resourceType !== resourceType || to.params.resourceId !== resourceId)) {
      next({
        name: 'editieren',
        params: {
          resourceType,
          resourceId
        }
      })
    } else {
      next()
    }
  },
  beforeRouteUpdate (to, from, next) {
    let resourceId = store.getters['editor/getId']
    let resourceType = store.getters['editor/getViewEntityType']
    if (to.params.resourceType !== resourceType || to.params.resourceId !== resourceId) {
      next({
        name: 'editieren',
        params: {
          resourceType,
          resourceId
        }
      })
    } else {
      next()
    }
  }
}
</script>

<style>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fob-box {
    box-shadow: 0 8px 6px -6px #777;
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityEdit.vue